import type { Activity } from '@paintscout/api'
import React from 'react'
import { formatName } from '@paintscout/util/builder'
import Highlight from '../Highlight'

export interface ActivityContactProps {
  activity: Activity
}

export default function ActivityContact(props: ActivityContactProps) {
  const { activity } = props

  const contact = activity.details.contact
  const name = formatName(contact)

  if (!name) {
    return null
  }

  return (
    <>
      {' '}
      by <Highlight>{name}</Highlight>
    </>
  )
}
